import { HttpClient, HttpContext } from '@angular/common/http';
import { Service, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ResponseApi } from '../../../core/dtos/response-api';
import { HANDLE_HTTP_ERROR_LOCALLY, SKIP_SUCCESS_ALERT } from '../../../core/http/http-context-tokens';

const RECURSO = `${environment.apiUrl}/sai/cartaservico/publico/avaliacao`;

/** O erro fica local: o modal do interceptor não entra no meio da avaliação. */
const ERRO_LOCAL = () => new HttpContext().set(HANDLE_HTTP_ERROR_LOCALLY, true).set(SKIP_SUCCESS_ALERT, true);

/** O que a tela envia. **Três campos, e só.** */
export interface AvaliacaoAtendimentoRequest {
  /** De 0 a 5. Zero é resposta válida ("Péssimo"), não ausência de resposta. */
  nota: number;
  /** Opcional. Branco chega ao back-end como ausente e é gravado como nulo. */
  comentario: string | null;
  /** O **caminho** da página (`location.pathname`), nunca a URL inteira. */
  caminho: string;
}

/** O 201 do back-end: a confirmação, sem identificador. */
export interface AvaliacaoAtendimentoResponse {
  registrada: boolean;
  dataRegistro: string;
}

/**
 * A pesquisa de satisfação do portal — o modal *Avaliação de Atendimento* do bloco
 * *"Sua voz é importante!"*, que aparece em quase todas as páginas.
 *
 * ⚠️ O que o portal **não** manda, e não é esquecimento:
 *
 * - **o órgão**: o back-end o resolve pelo **host** de quem chamou. Mandar `codOrgaoOrg`
 *   devolve 400 nomeando o campo. Até 14/10/2026 a tela mandava, lido do `localStorage`,
 *   o que em rota anônima deixava qualquer um gravar avaliação no órgão que quisesse;
 * - **o IP**: não trafega e não é gravado. A chamada ao `api.ipify.org` saiu da tela
 *   junto com o campo — ela contava a um serviço de terceiro que aquele visitante estava
 *   avaliando o portal;
 * - **a origem** (SIC / Ouvidoria / Carta de Serviço): é derivada do caminho, no servidor;
 * - **a data de envio** e **o identificador**: são do sistema.
 *
 * A rota é nova: o `POST /Feedback/SalvarFeedbackPortal` que a tela chamava **nunca existiu**
 * nesta API — só no SAI legado —, e por isso toda avaliação enviada até aqui falhava.
 */
@Service()
export class AvaliacaoAtendimentoService {
  private readonly http = inject(HttpClient);

  /**
   * Registra a avaliação. O alerta automático de sucesso é silenciado: quem agradece ao
   * cidadão é o SweetAlert da própria tela.
   */
  registrar(dados: AvaliacaoAtendimentoRequest): Observable<AvaliacaoAtendimentoResponse> {
    return this.http
      .post<ResponseApi<AvaliacaoAtendimentoResponse>>(RECURSO, dados, { context: ERRO_LOCAL() })
      .pipe(map((resposta) => resposta.data));
  }
}
